export default __webpack_public_path__ + "5dbcbeb65f2af51b42b5bbdca730c529.png";